import * as t from "io-ts"

// A flight both represents the flight as requested or stored
// but also a line in a transaction, in which case
// transLineNum, requestCode, responseCode, statusCode, replyOptions and replyCode are set
export const TFlight = t.interface({
  flightId: t.number,
  airport: t.string,
  operatorArr: t.string,
  serviceNoArr: t.string,
  operatorDep: t.string,
  serviceNoDep: t.string,
  startDate: t.string,
  endDate: t.string,
  requiredDateArr: t.string,
  requiredDateDep: t.string,
  doop: t.string,
  numSeats: t.string,
  aircraftType: t.string,
  originStation: t.string,
  lastStation: t.string,
  clearedTimeArr: t.string,
  clearedTimeDep: t.string,
  turnaroundDays: t.number,
  nextStation: t.string,
  destinationStation: t.string,
  serviceTypeArr: t.string,
  serviceTypeDep: t.string,
  woop: t.number,
  aircraftRegistration: t.string,
  requiredTimeArr: t.string,
  requiredTimeDep: t.string,
  reasonCodeArr: t.string,
  reasonCodeDep: t.string,
  minGroundTime: t.number,
  offerTimeArrFrom: t.string,
  offerTimeArrTo: t.string,
  offerTimeDepFrom: t.string,
  offerTimeDepTo: t.string,
  permissionCode: t.string, // not used by FE, but must be returned as it was
  terminalArr: t.string,
  terminalDep: t.string,
  requestCode: t.string, // SSIM: N: New, C: to be changed, R: Revised, D: Delete, ...
  responseCode: t.string, // SSIM: K: confirmed, T: tentative, H: held (you have this), X: deleted, U: unable, O: offer, ...
  slotIdArr: t.string,
  slotIdDep: t.string,
  noOfOperations: t.number,
  selectionStatus: t.string, // is flight currently part of a transaction ? "": no, "0" partly, "1" fully, "2" no checkbox (EditFlightsSD only)
  startsOutsideSelection: t.boolean,
  flightMode: t.string, // A, D or T (for arrival, departure or turnaround respectively)
  transLineNum: t.number, // this flight is a line in a transaction and has this number
  statusCode: t.number, // color code for this line: 0: None, 1: Cleared (green), 2: Offered (yellow), 3: Refused (red)
  replyOptions: t.array(t.string), // possible reply codes for this line, list may be empty
  replyCode: t.string, // *: <empty>, A: Accept, P: Pend, C: Cancel, S: Ask us, O: Override, R: Refuse, L: Live only
  handler: t.string,
  vfr: t.boolean,
  towbar: t.boolean,
  mtow: t.number,
  gabaLounge: t.boolean,
  refuelling: t.boolean,
  operatorText: t.string,
  parkingLocation: t.string,
  noiseCertificate: t.string
})
export const TFlights = t.array(TFlight)

export type Flight = t.TypeOf<typeof TFlight>
export type Flights = t.TypeOf<typeof TFlights>
